<div class="workflow-container">
  <h2>{{ screenTitle }}</h2>

  <mat-horizontal-stepper
    #stepper
    [linear]="false"
    [selectedIndex]="activeStep"
    (selectionChange)="onStepChange($event)"
    labelPosition="bottom"
    class="wf-stepper">
    <mat-step *ngFor="let step of steps; let i = index">
      <ng-template matStepLabel>{{ step.title }}</ng-template>

      <form [formGroup]="form" class="step-form">
        <div class="bulk-bar" *ngIf="selectedFields.size > 0">
          <div class="bulk-left">
            <span>{{ selectedFields.size }} Items selected</span>
          </div>

          <div class="bulk-right">
            <select (change)="applyBulk($event.target.value)">
              <option value="">Action</option>
              <option *ngFor="let opt of bulkOptions" [value]="opt.value">
                {{ opt.label }}
              </option>
            </select>
            <button type="button" class="clear-btn" (click)="clearSelection()">Clear</button>
          </div>
        </div>

        <div class="row table-header">
          <div class="col checkbox-col" *ngIf="massAction">
            <input type="checkbox" [checked]="selectAllChecked" (change)="onToggleSelectAll($event)" />
          </div>

          <div class="col label-col">Label</div>
          <div class="col input-col">Value</div>
        </div>

        <div class="row" *ngFor="let f of steps[activeStep].blueprint">
          <div class="col checkbox-col" *ngIf="massAction">
            <input type="checkbox" [checked]="selectedFields.has(f.fieldId)" (change)="toggleSelection(f.fieldId)" />
          </div>

          <div class="col label-col">
            {{ f.label
            }}<i
              class="fa fa-info-circle ms-1 text-muted"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              *ngIf="f.tooltip"
              [title]="f.tooltip">
            </i>
          </div>

          <div class="col input-col">
            <ng-container *ngIf="!isFreeText(f); else freeTpl">
              <select [formControlName]="f.fieldId">
                <option *ngFor="let o of getOptions(f)" [value]="o.value">
                  {{ o.label }}
                </option>
              </select>
            </ng-container>

            <ng-template #freeTpl>
              <textarea [formControlName]="f.fieldId" rows="2"></textarea>
            </ng-template>
          </div>
        </div>

        <div class="actions">
          <button type="button" class="btn-discard" (click)="goBack(stepper)" [disabled]="i === 0">Back</button>

          <button type="button" class="btn-primary" (click)="saveAndNext(stepper)">Proceed</button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
